import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '../errors/api-error';

/** One client for the whole app: no retries on client errors, gentle retries on connection loss. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: 0 },
  },
});
